import axios from '@plugins/axios'
import getSecret from '@utils/get-secret'
let serverUrl = getSecret('SERVER_URL');
//let serverUrl = ("http://localhost:3000")
import i18n from '@plugins/i18n'

export const getters = {
  getTematicFields() {
    return {
      model: 'repositories_tematics',
      label: 'Tematics',
      fields: [
        { key: 'name', label: 'Name', type: 'text', sortable: true, required: true },
        { key: 'description', label: 'Description', type: 'text', sortable: true, required: false }
      ]
    }
  },
}

export const actions = {
  async fetchTematics(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/tematics/${query}`)
      .then((response) => {
        return response.data;
      })
  },

  async fetchTematicsFilter(context, query = '') {
    return axios
      .get(`${serverUrl}/api/masters/tematics/listForFilters`)
      .then((response) => {
        return response.data;
      })
  },


  async createTematics(context, { payload }) {
    return axios
      .post(`${serverUrl}/api/masters/tematics/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async updateTematics(context, { payload }) {
    return axios
      .patch(`${serverUrl}/api/masters/tematics/${payload.id}/`, payload)
      .then((response) => {
        return response.data;
      })
  },

  async deleteTematics(context, { id }) {
    return axios
      .delete(`${serverUrl}/api/masters/tematics/${id}/`)
      .then((response) => {
        return response.data;
      })
  }
}